import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Action } from '@ngrx/store';
import { CompanyActions, CompanyActionTypes } from './company.actions';
import { CompanyEntity } from './company.model';

export type CompanyEntities = EntityState<CompanyEntity>;

export const adapter: EntityAdapter<CompanyEntity> = createEntityAdapter<CompanyEntity>();

export const initialState: CompanyEntities = adapter.getInitialState({
  // additional entity state properties
});

export function reducer(state = initialState, incomingAction: Action): CompanyEntities {
  const action: CompanyActions = incomingAction as CompanyActions;
  switch (action.type) {
    case CompanyActionTypes.AddCompany: {
      return adapter.addOne(action.payload.company, state);
    }

    case CompanyActionTypes.UpsertCompany: {
      return adapter.upsertOne(action.payload.company, state);
    }

    case CompanyActionTypes.AddCompanys: {
      return adapter.addMany(action.payload.companys, state);
    }

    case CompanyActionTypes.UpsertCompanys: {
      return adapter.upsertMany(action.payload.companys, state);
    }

    case CompanyActionTypes.UpdateCompany: {
      return adapter.updateOne(action.payload.company, state);
    }

    case CompanyActionTypes.UpdateCompanys: {
      return adapter.updateMany(action.payload.companys, state);
    }

    case CompanyActionTypes.DeleteCompany: {
      return adapter.removeOne(action.payload.id, state);
    }

    case CompanyActionTypes.DeleteCompanys: {
      return adapter.removeMany(action.payload.ids, state);
    }

    case CompanyActionTypes.LoadCompanys: {
      return adapter.setAll(action.payload.companys, state);
    }

    case CompanyActionTypes.ClearCompanys: {
      return adapter.removeAll(state);
    }

    default: {
      return state;
    }
  }
}

export const { selectIds, selectEntities, selectAll, selectTotal } = adapter.getSelectors();
